import { styled } from 'stitches.config'
import { Button } from 'components/Button'

export const FeedBetterRoot = styled('section', {
  color: '$accent-black',
  padding: '$4 0 $5',
  '@bp2': {
    padding: '$7 $4 $10',
  },
})

export const HeaderBox = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: '24px',
  gap: '16px',
  padding: '0 $2',

  '@bp2': {
    marginBottom: '52px',
    gap: '$3',
  },
})

export const Header = styled('h2', {
  fontSize: '$h3',
  width: '100%',
  textAlign: 'center',
  maxWidth: '200px',
  lineHeight: 'normal',
  '@bp2': {
    lineHeight: '$h1',
    fontSize: '$h1',
    maxWidth: '100%',
  },
})

export const SubHeader = styled('h3', {
  fontSize: '$body',
  fontFamily: '$primary',
  textAlign: 'center',
  maxWidth: '380px',

  '@bp2': {
    maxWidth: '1400px',
    fontSize: '$h3',
    fontFamily: '$display',
  },
})

export const RecipesBox = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  margin: 'auto',
  marginBottom: 0,
  gap: '0px',
  flexDirection: 'column',
  maxWidth: '500px',

  '&.freeze': {
    flexDirection: 'column-reverse',
  },

  '@bp2': {
    flexDirection: 'row',
    maxWidth: '1292px',
    gap: '42px',
    marginBottom: '32px',
    '&.freeze': {
      flexDirection: 'row',
    },
  },

  '@bp3': {
    gap: '68px',
    marginBottom: '48px',
  },

  '&:last-child': {
    marginBottom: 0,
  },
})

export const ImageColumn = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
})

export const RecipesColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '$3',
  padding: '$4 $2 $5',
  alignItems: 'center',

  '@bp2': {
    padding: 0,
    paddingRight: '$4',
    gap: '$3',
    alignItems: 'flex-start',

    '&.freeze': {
      paddingLeft: '$4',
      paddingRight: 0,
    },
  },
  '@bp3': {
    paddingRight: '$8',
    gap: '$4',

    '&.freeze': {
      paddingLeft: '$8',
      paddingRight: 0,
    },
  },
})

export const BodyBox = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',
})

export const Title = styled('h3', {
  fontSize: '$h5',
  fontWeight: '$regular',
  fontFamily: '$label',
})

export const Description = styled('p', {
  fontSize: '$body',
})

export const RecipeIcons = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  width: '100%',
})

export const IconWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '16px',
  width: '50%',
  marginBottom: '28px',
  paddingRight: '8px',
  cursor: 'pointer',

  '&:last-child, &:nth-last-child(2)': {
    marginBottom: '0px',
  },
  '@bp2': {
    padding: 0,
  },
})

export const IconImage = styled('div', {
  position: 'relative',
  width: 0,
  height: 0,

  '@mobile': {
    width: '53px',
    height: '53px',
  },
})

export const ImageWrapper = styled('div', {
  position: 'relative',
  width: '500px',
  aspectRatio: '1.435/1',

  '&.freeze': {
    aspectRatio: '1.45/1',
  },

  '@bp2': {
    aspectRatio: 'unset',
    width: '507px',
    height: '382px',

    '&.freeze': {
      width: '507px',
      height: '350px',
    },
  },

  '@bp3': {
    width: '634px',
    height: '477px',

    '&.freeze': {
      width: '634px',
      height: '438px',
    },
  },
})

export const SeeMoreButton = styled(Button, {
  width: '100%',
  maxWidth: '230px',
  marginTop: '$1',

  '&.freeze': {
    maxWidth: '280px',
  },
  '@bp2': {
    margin: 0,
  },
})

export const CtaButtonBox = styled('div', {
  width: '100%',
  textAlign: 'center',
  marginTop: '12px',
  padding: '0 $2',
  '& button': {
    width: '100%',
    maxWidth: '280px',
  },

  '@bp2': {
    marginTop: '48px',
  },
})
